import { forwardRef } from 'react';
import { cn } from 'lib/utils';
import { NavItem } from './nav-item';
import { NavItemCollapsible } from './nav-item-collapsible';
import type { SidebarSectionProps } from './types';

const SidebarSection = forwardRef<HTMLElement, SidebarSectionProps>(
  ({ section, onNavigate, isCollapsed = false, className }, ref) => {
    if (section.items.length === 0) {
      return null;
    }

    return (
      <section
        ref={ref}
        className={className}
        aria-label={section.heading || `Navigation section ${section.id}`}
      >
        {section.showDivider && (
          <hr
            className="my-3 border-t border-gray-blue-10"
            aria-hidden="true"
          />
        )}

        <nav aria-label={section.heading || 'Sidebar navigation'}>
          <ul className="m-0 p-0 list-none">
            {section.items.map((item) => (
              <li key={item.id}>
                {item.children && item.children.length > 0 ? (
                  <NavItemCollapsible
                    item={item}
                    onNavigate={onNavigate}
                    isCollapsed={isCollapsed}
                  />
                ) : (
                  <NavItem
                    item={item}
                    onNavigate={onNavigate}
                    isCollapsed={isCollapsed}
                  />
                )}
              </li>
            ))}
          </ul>
        </nav>
      </section>
    );
  }
);

SidebarSection.displayName = 'SidebarSection';

export { SidebarSection };
